import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-367e0644"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "table-containe-top-slot"
}
const _hoisted_2 = { class: "table-grid" }
const _hoisted_3 = {
  key: 1,
  class: "table-containe-empty-data-slot"
}
const _hoisted_4 = {
  key: 2,
  class: "table-containe-bottom-slot"
}

import { computed, PropType, useSlots } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TirPmTable',
  props: {
  /**
   * Есть ли граница у общего контейнера
   */
  isBordered: {
    type: Boolean as PropType<Boolean>,
    default: true,
  },
  /**
   * Массив с ширинами колонок
   */
  columns: { type: Array as PropType<string[]>, default: () => [] },
  /**
   * Массив с данными
   */
  data: { type: Array as PropType<Array<T>>, default: () => [] },
  /**
   * * Минимальная ширина
   */
  minWidth: {
    type: String as PropType<string>,
  },
},
  emits: ["onScroll"],
  setup(__props, { emit: emits }) {

const props = __props;


// Определение эмиттеров событий компонента


const onScroll = function (event: any) {
  emits("onScroll", event);
};
let widthColumns = computed(() => {
  if (props.columns.length) return props.columns.join(" ");
  return "repeat(auto-fill, minmax(6.25rem, 1fr))";
});

const slots = useSlots();

/**
 * Есть ли слот сверху
 */
const isFilledTopSlot = computed(
  () => slots && slots.topSlot && slots.topSlot()
);
/**
 * Есть ли слот снизу (обычно под пагинацию)
 */
const isFilledBottomSlot = computed(
  () => slots && slots.bottomSlot && slots.bottomSlot()
);
/**
 * Есть ли слот снизу под пустой контент (обычно под компонент SystemMessage)
 */
const isFilledEmptyDataSlot = computed(
  () => slots && slots.emptyDataSlot && slots.emptyDataSlot()
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["table-container", {
      'table-container--bordered': props.isBordered,
    }])
  }, [
    (isFilledTopSlot.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "topSlot")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "table-grid-header",
        style: _normalizeStyle({ 'grid-template-columns': _unref(widthColumns) })
      }, [
        _renderSlot(_ctx.$slots, "tableHead", {}, () => [
          _createTextVNode(_toDisplayString(_unref(widthColumns)), 1)
        ])
      ], 4),
      _createElementVNode("div", {
        class: "table-grid-body",
        onScroll: onScroll
      }, [
        _renderSlot(_ctx.$slots, "tableBody")
      ], 32)
    ]),
    (isFilledEmptyDataSlot.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "emptyDataSlot")
        ]))
      : _createCommentVNode("", true),
    (isFilledBottomSlot.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "bottomSlot")
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})